module.exports = __webpack_public_path__ + "static/media/logo-ensina-by-fs-black.ac6d0c67.png";